import { AdapterBase, RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { MapModel } from "../../storyV2/model/MapModel";
export class MapAdapter extends AdapterBase {
    runResponseType() {
        return RunResponseType.MAP;
    }
    async runNode(node, actionData, story, edge) {
        const textGenFunc = this.funcRegistry.createTextGenFunction("/be/bas-demo-v4/nlp/completions_generation", "file", "json_list_converter.model", undefined, "brain_studios");
        /// 生成文本
        const textGenRes = await textGenFunc.run(node.content, { projectId: story.projectId, edgeId: edge.options.id });
        const mapModel = new MapModel(textGenRes.data, new Date().getTime());
        return mapModel;
    }
}
